import details from './details'
import payments from './payments'
import team from './team'
import uploads from './uploads'

import $ from 'jquery'
import store from '@/store'
import api from '@/api/Api'
import common from '../common'
import misc from '../misc'
import { bus } from '../../Bus'

export const path = (project) => {
    return project.type+'/'+project.id
}

export const setAsCurrent = (project) => {
    let position = path(project).split('/').length - 1
    
    store.dispatch('project/setCurrent', {
        position: position,
        data: project
    })
}

export const current = () => {
    let d = store.getters['project/current']
    return d[d.length-1]
}

export const files = (project, type, query, forceSync, linkedId) => {
    let data
    
    if(linkedId)
        data = store.getters['files/'+type](project.id, linkedId)
    else
        data = store.getters['files/'+type](project.id)
    
    if(query === true)
        return data
    
    let wait = $.Deferred()
    
    if(data.isLoaded && data.npk === '' && !forceSync)
        return wait.resolve({ files: [] }).promise()
    
    query.projectId = project.id
    query.npk = data.npk
    
    api.get('/Files/getList', query).then(
        (r) => {
            let out = {
                id: project.id,
                linkedId: linkedId,
                forceSync: forceSync,
                files: r.data.files,
                npk: r.data.npk || ''
            }
            
            store.dispatch('files/'+type, out)
            
            if(query.npk === '' && !forceSync)
                bus.$emit('files'+misc.ucfirst(type)+'Loaded', project)
            else
                bus.$emit('files'+misc.ucfirst(type)+'Updated', project)
            
            return wait.resolve(out).promise()
        },
        (r) => {
            return wait.reject(api.getError(r)).promise()
        }
    )
    
    return wait.promise()
}

export const update = (project, payload) => {
    let wait = $.Deferred()
    
    api.put('/Project/details/'+path(project), payload, true, {}, api.CONTENT_TYPE_BODY).then(
        (r) => {
            return wait.resolve(r.data).promise()
        },
        (r) => {
            return wait.reject(api.getError(r)).promise()
        }
    )
    
    return wait.promise()
}

// set `returnOnly` to `false` to get from server instead using cache
export const info = (project, returnOnly, forceSync) => {
    let wait = $.Deferred()
    
    let params = {}
    
    if(returnOnly)
        params.returnOnly = returnOnly
    
    if(forceSync)
        params.forceSync = forceSync
    
    let data = store.getters['project/get'](project.id)
    
    if(data && !Object.keys(params).length && returnOnly !== false)
        return wait.resolve(data).promise()
    
    let isScreenBlocked = false
    
    if(!project.lastSync && !params.returnOnly) {
        isScreenBlocked = true
        misc.blockScreen('This '+common.getProjectTypeName(project.type)+' opened first time, so synchronising data may take few more seconds. please wait...')
    }
    
    api.get('/Project/details/'+path(project), params).then(
        (r) => {
            if(params.returnOnly) {
                store.dispatch('project/mergeInfo', {
                    id: project.id,
                    paths: returnOnly,
                    payload: r.data.result
                }).then(() => {
                    bus.$emit('projectInfoUpdated', project)
                })
            }
            else {
                store.dispatch('project/setFullInfo', r.data.result).then(() => {
                    if(returnOnly === false)
                        bus.$emit('projectInfoUpdated', project)
                    else
                        bus.$emit('projectInfoLoaded', project)
                })
            }
            
            if(isScreenBlocked)
                misc.releaseScreen()
            
            return wait.resolve(r.data.result).promise()
        },
        (r) => {
            if(isScreenBlocked)
                misc.releaseScreen()
            
            return wait.reject(api.getError(r)).promise()
        }
    )
    
    return wait.promise()
}

export const download = (project, docType, docId) => {
    let wait = $.Deferred()
    
    misc.blockScreen('Preparing download. please wait...')
    
    api.get('/Project/download/'+path(project), {
        docType: docType,
        docId: docId
    }, true).then(
        (r) => {
            if(!r.data.downloadUrl)
                misc.notify('E', 'Download link not found!', 'Error')
            else
                misc.download(r.data.downloadUrl)
            
            setTimeout(() => {
                misc.releaseScreen()
            }, 1000)
            
            return wait.resolve(true).promise()
        },
        (r) => {
            misc.releaseScreen()
            misc.notify('E', api.getError(r))
            return wait.reject(false).promise()
        }
    )
    
    return wait.promise()
}

export const id = (id) => {
    id = id.toString()
    
    while(id.length < 10)
        id = '0'+id
    
    return id
}

export const isRegistrationPaymentPending = (project) => {
    return /Registration Incomplete/.test(project.status)
}

export const isRegistrationAllowed = (type, serverTime) => {
    let token = store.state.api.token
    if(!token)
        return false
    
    if(typeof window.Vue.$route.query.__allowMe !== 'undefined') {
        let val = window.Vue.$route.query.__allowMe
        if(val === 'Y') {
            localStorage.setItem('__allowMe', token)
            return true
        }
        
        localStorage.removeItem('__allowMe')
    }
    
    if(localStorage.getItem('__allowMe') === token)
        return true
    
    const sunsetTimestamps = {
        campus: {
            DEV: 1764997199,
            STG: 1764997199,
            QAS: 1764997199,
            PRD: 1767243599
        },
        utility: {
            DEV: 1764997199,
            STG: 1764997199,
            QAS: 1764997199,
            PRD: 1767243599
        },
        transit: {
            DEV: 1764997199,
            STG: 1764997199,
            QAS: 1764997199,
            PRD: 1767243599
        }
    }
    
    let env = common.environment()
    if(!env || !sunsetTimestamps[type][env])
        return false
    
    return serverTime <= sunsetTimestamps[type][env]
}

export default {
    path, files, info, setAsCurrent, current,
    details, update,
    payments,
    team,
    uploads,
    download,
    id,
    isRegistrationPaymentPending,
    isRegistrationAllowed
}
